import { InvoiceStatusFilter } from './Invoices.types';

export const DEFAULT_PAGE_SIZE = 24;

export const INVOICES_TABLE_COLUMNS =
  '0.9fr 0.7fr 1.5fr 0.7fr minmax(150px, 1.2fr) minmax(100px, 0.9fr) 24px 14px';

export const STATUS_TABS: { value: InvoiceStatusFilter; labelKey: string }[] = [
  { value: InvoiceStatusFilter.All, labelKey: 'common.all' },
  { value: InvoiceStatusFilter.Paid, labelKey: 'pages.cabinet.paid_tab' },
  {
    value: InvoiceStatusFilter.Unpaid,
    labelKey: 'pages.cabinet.unpaid_tab',
  },
  {
    value: InvoiceStatusFilter.Canceled,
    labelKey: 'pages.cabinet.canceled_tab',
  },
  {
    value: InvoiceStatusFilter.Overdue,
    labelKey: 'pages.cabinet.overdue_tab',
  },
  {
    value: InvoiceStatusFilter.Revoked,
    labelKey: 'pages.cabinet.revoked_tab',
  },
];
